import { ProductError } from '@masterofmalt/atom.componentlibrary/contexts/dataLoaderContext';
import { IProductModel } from '@masterofmalt/atom.componentlibrary/models/internal/product/IProductModel';

import { PriceConfig } from '~/lib/atom/types/price-config';

import { ActivePromotion } from '../atom/types/active-promotion';

import { getProducts } from './get-products';

export const getProductsBySku = async (
  productIds: readonly number[],
  priceConfig: PriceConfig,
  promotions: ActivePromotion[] = [],
): Promise<Array<IProductModel | ProductError>> => {
  if (productIds.some((id) => typeof id !== 'number')) {
    throw new Error('Product IDs must be numbers');
  }

  const products = await getProducts(
    {
      filters: productIds.map((id) => `sku:${id}`).join(' OR '),
      analytics: false,
      analyticsTags: ['sku'],
    },
    priceConfig,
    promotions,
  );

  // We need to map the passed in productIds to the hits returned from Algolia
  // as the order of the hits returned is not guaranteed to match the order of the productIds
  // and we need to return an error for any productIds that don't have a corresponding hit
  return productIds.map(
    (sku) =>
      products.find(({ id }) => id === sku) || {
        _id: sku,
        error: true,
      },
  );
};
